<template>
  <router-view />
</template>

<script>
export default {
  name: 'SchemesEditTradesRouter',
};
</script>
